import React from 'react';
import classNames from 'classnames';
import PAPFormBottomNav from 'pap/containers/common/bottom_nav';
import PAPProgressBar from 'pap/containers/common/progress_bar';
import { LoadingIndicator } from 'common/components/preloader';
import CreativeHeader1to1 from 'common/components/creative_header_1_1';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import IntercomChat from 'pap/containers/intercom_chat';

/**
 * This component helps us DRY the structure and only use the ProgressBar and BottomNav in one
 * place.
 */
class PAPBase extends React.Component {

  constructor(props) {
    super(props);

    this.state = { backwards: false };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentStepIndex > nextProps.currentStepIndex) {
      this.setState({ backwards: true });
    } else if (this.props.currentStepIndex < nextProps.currentStepIndex) {
      this.setState({ backwards: false });
    }
  }

  render() {
    const {
      loadingData, extraClasses, location, sectionName, currentStepIndex, stepCount,
      currentSectionStepCount, creative1to1, bottomNavHidden, onPrevStep, onNextStep,
      children, prevEnabled, nextEnabled, currentFeatures, currentAwards, awardValue1to1,
      formValues, subCategory, categorySlug, nextLabel, packageName, billables,
      user, currentTips, hidePrice, onSave, saveEnabled, saveLabel,
      subCategorySlug
    } = this.props

    if (loadingData) {
      return <div className="l-content"><LoadingIndicator /></div>
    }

    const classes = classNames(extraClasses || [], "l-content", {
      backwards: this.state.backwards
    });

    return <div className={classes} id="content">
     <Meta
        title="Start a project"
        meta={[{ name: "robots", content: "noindex,follow" }]}
        link={[{
          rel: "canonical",
          href: getCanonicalURL(
            "/start-a-project/" + categorySlug + "/" + (subCategorySlug || "") + "/details/package"
          )
        }]}
      />
      <PAPProgressBar
        currentSectionName={sectionName}
        currentStep={currentStepIndex}
        stepCount={stepCount}
        currentSectionStepCount={currentSectionStepCount}
        is1to1={!!creative1to1} />

      { creative1to1 && subCategory &&
      <CreativeHeader1to1 creative={creative1to1} subcatName={subCategory.name}/> }

      <div className="pap-form">{ children }</div>

      {!bottomNavHidden &&
        <PAPFormBottomNav
          onPrevStep={onPrevStep.bind(this)}
          onNextStep={onNextStep.bind(this)}
          onSave={onSave}
          prevEnabled={prevEnabled}
          nextEnabled={nextEnabled}
          saveEnabled={saveEnabled}
          saveLabel={saveLabel}
          nextLabel={nextLabel}
          packageName={packageName}
          currentFeatures={currentFeatures || []}
          currentAwards={currentAwards || []}
          currentTips={currentTips || []}
          billables={billables}
          formValues={formValues || {}}
          awardValue1to1={awardValue1to1}
          hidePrice={hidePrice}
          user={user}
          subCategorySlug={subCategorySlug} />}

      <IntercomChat bodyClasses={classNames({ "with-bottom-nav": !bottomNavHidden })} />
    </div>
  }
}

export default PAPBase



// WEBPACK FOOTER //
// ./pap/components/common/pap_base.jsx